import Stack from "@mui/material/Stack";
import { useStudiosListQuery } from "entities/studios/queries/useStudiosListQuery";
import React, { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { useStudiosData } from "../../../../stores/useStudiosData";
import StudiosAutocomplete, {
  StudioOption,
} from "./components/StudiosAutocomplete";

const Studios: FC = () => {
  const { selectedStudios, setSelectedStudios } = useStudiosData();
  const { data: studioOptions, isLoading } = useStudiosListQuery();

  const formattedStudioOptions =
    studioOptions?.map((studio) => ({
      id: String(studio.id),
      name: studio.name,
    })) ?? [];

  const handleChangeStudios = (value: StudioOption[]) => {
    setSelectedStudios(value);
  };

  return (
    <Stack spacing="1rem">
      <ContentSection title="STUDIOS">
        <StudiosAutocomplete
          value={selectedStudios}
          options={formattedStudioOptions}
          placeholder="Add a studio..."
          onChange={handleChangeStudios}
          loading={isLoading}
        />
      </ContentSection>
    </Stack>
  );
};

export default Studios;
